import { Stack } from 'expo-router'
import { stableStackOptions } from '../../../../lib/navigation/stable-stack-options'

export default function OrganizationLayout() {
  return <Stack screenOptions={{ headerShown: false, ...stableStackOptions }} />
}
